import React from 'react';
import i18n from '../translations';
import { sweetAlert } from './sweetAlert';

/**
 * Shows validation errors in a modal grouped by field type
 * @param {Array} missingFields - Array of missing required fields with name, label, and type
 * @param {Object} alertOptions - Extra SweetAlert options (the Moderne preset opens the modal inside the form)
 * @returns {Promise} - Promise that resolves with the SweetAlert result object when the modal is closed
 */
export const showValidationErrors = async (missingFields, alertOptions = {}) => {
  // Group fields by type for better organization
  const fieldGroups = {
    text: [],
    select: [],
    checkbox: [],
  };

  missingFields.forEach((field) => {
    switch (field.type) {
      case 'RadioField':
      case 'SelectField':
      case 'MultiSelectField':
      case 'CountrySelectField':
      case 'DateSelectField':
        fieldGroups.select.push(field);
        break;
      case 'CheckboxField':
        fieldGroups.checkbox.push(field);
        break;
      default:
        fieldGroups.text.push(field);
    }
  });

  // Build the HTML content with grouped fields
  const buildFieldList = (fields) => (
    <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
      {fields.map((field) => (
        <li key={field.name} style={{ margin: '4px 0', fontSize: '14px' }}>
          {field.label}
        </li>
      ))}
    </ul>
  );

  const FieldGroupSection = ({ fields, translationKey }) =>
    fields.length > 0 && (
      <div style={{ marginBottom: '16px' }}>
        <strong style={{ fontSize: '14px' }}>{i18n.t(translationKey)}:</strong>
        {buildFieldList(fields)}
      </div>
    );

  const fieldGroupsConfig = [
    { fields: fieldGroups.text, translationKey: 'validation.text-fields-required' },
    { fields: fieldGroups.select, translationKey: 'validation.selection-required' },
    { fields: fieldGroups.checkbox, translationKey: 'validation.checkbox-required' },
  ];

  const content = (
    <div style={{ textAlign: 'left' }}>
      {fieldGroupsConfig.map(({ fields, translationKey }, index) => (
        <FieldGroupSection key={index} fields={fields} translationKey={translationKey} />
      ))}
    </div>
  );

  const result = await sweetAlert({
    ...alertOptions,
    icon: 'warning',
    width: '60%',
    title: i18n.t('validation.missing-fields-title'),
    html: content,
  });

  return result;
};
